import events from '../events';

const CSS_BLOCK_NAME = 'slx-product-wizard-button';
const CSS_ACTIVE_MODIFIER_NAME = `${CSS_BLOCK_NAME}--active`;
const DATA_ATTRIBUTE_NAME = 'data-slx-product-type-id';
const DATA_FACET_ATTRIBUTE_NAME = 'data-slx-facet-id';

const buttons = document.queryAll(`.${CSS_BLOCK_NAME}`);

buttons.forEach((button) => {
	const productTypeId = parseInt(button.getAttribute(DATA_ATTRIBUTE_NAME), 10);
	const facetId = parseInt(button.getAttribute(DATA_FACET_ATTRIBUTE_NAME), 10);

	events.on('selectedProductTypeInWizard', (selectedProductTypeId) => {
		const isSelected = productTypeId === selectedProductTypeId;
		button.classList[isSelected ? 'add' : 'remove'](CSS_ACTIVE_MODIFIER_NAME);
	});

	button.addEventListener('click', () => {
		events.emit('selectProductTypeInWizard', productTypeId, facetId);
		button.classList.add(CSS_ACTIVE_MODIFIER_NAME);
	});
});
